import { render, staticRenderFns } from "./investStartup.vue?vue&type=template&id=3c2b2b72&scoped=true&"
import script from "./investStartup.vue?vue&type=script&lang=js&"
export * from "./investStartup.vue?vue&type=script&lang=js&"
import style0 from "./investStartup.vue?vue&type=style&index=0&id=3c2b2b72&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c2b2b72",
  null
  
)

export default component.exports